import { useEffect, useState } from 'react';
import { get } from '../../helpers/api';
import { useToast } from '../../hooks';

/**
 * Loads `/admin/ride/:id`. `status` is 'loading' | 'notFound' | 'error' |
 * 'ready'; `ride` is only set when ready, and is cleared on an id change so the
 * previous ride never shows under the new id.
 */
const useRide = (id) => {
  const t = useToast();
  const [ride, setRide] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setStatus('loading');
      setRide(null);
      try {
        const response = await get(`/admin/ride/${id}`);
        if (cancelled) return;
        setRide(response.data);
        setStatus('ready');
      } catch (err) {
        if (cancelled) return;
        if (err?.response?.status === 404) {
          setStatus('notFound');
        } else {
          console.error('Error fetching ride:', err);
          setStatus('error');
          t.error('There was an error loading this ride');
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { ride, status };
};

export default useRide;
